//Please add the language resource
const orderMiv = {
  orderNo:'orderNo',
  url:'url',
  createTime:"createTime",
  pushTime:"pushTime",
  confirmTime:"confirmTime",
  pushStatus:"pushStatus",
  pushResult:"pushResult",
  msg:{
  }
};
export default orderMiv



// WEBPACK FOOTER //
// ./src/page/orderMiv/lang/orderMiv.en.js